<template>
  <v-radio-group
    class="custom-radio-group"
    hide-details
    density="compact"
    v-model="radioValue"
    @change="() => onChange(radioValue)"
  >
    <v-radio
      v-for="item in items"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></v-radio>
  </v-radio-group>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
const props = defineProps<{
  items: Array<{ label: string; value: string }>;
  value: string;
  onChange: (value: string) => void;
}>();

const radioValue = ref(props.value);

watch(
  () => props.value,
  (value) => {
    radioValue.value = value;
  },
);
</script>
<style lang="postcss" src="../selection-group.css"></style>
